
import { useLetPassAccountVM } from "presentation/hook/LetPassAccount/useLetPassAccountVM";
import { useLetPassAccountTracked } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { LetPassAccountRightPanel } from "./LetPassAccountRightPanel";
import LetPassAccountSearchPanel from "./LetPassAccountSearchPanel";
import LetPassAccountTitleBar from "./LetPassAccountTitleBar";

export const LetPassAccountMaintenance: React.FC = () => {
    const [letPassAccountState] = useLetPassAccountTracked();
    const letPassAccountVM = useLetPassAccountVM();
    const { isShowSearchPanel } = letPassAccountState;
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    letPassAccountVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {
                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            setIsLoading(false);
        });

    }, [letPassAccountVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${(isShowSearchPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <LetPassAccountTitleBar />
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowSearchPanel ? '30%' : '0%'}
                rightSectionWidth={isShowSearchPanel ? "70%" : '100%'}
                leftChildren={<LetPassAccountSearchPanel />}
                rightChildren={<LetPassAccountRightPanel />}
            />
        </div>
    </>
}